var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('strong',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._l((_vm.body),function(item){return _c('p',[_vm._v(_vm._s(item))])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }